import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import { updateUser } from 'actions/clinic_admins';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import axios from 'axios';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import LocaleSelect from 'components/global/LocaleSelect';
import { API_URL } from '../../../environment';

const theme = createTheme();

const SignIn = props => {
  const [apiError, setApiError] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const credentials = {
      email: data.get('email'),
      password: data.get('password'),
    };

    try {
      const response = await axios.post(
        `${API_URL}/clinic_admin/sessions`,
        credentials,
      );
      const token = response.data.access_token;
      localStorage.setItem('token', token);
      props.updateUser({ locale: localStorage.getItem('locale') });
      props.history.push('/dashboard_clinic');
    } catch (error) {
      const errorData = error.response.data;
      let combinedErrorMessage = '';

      if (errorData.errors) {
        combinedErrorMessage = errorData.errors
          .map(err => `${err.source.pointer}: ${err.detail}`)
          .join('\n');
        setApiError(combinedErrorMessage);
      } else {
        let errorMessage = `${props.intl.formatMessage({
          defaultMessage: 'Something went wrong',
        })}: `;
        errorMessage += error?.response?.data?.error || '';
        setApiError(errorMessage);
      }
    }
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div style={{ marginBottom: '100px' }}>
            <AppBar position="absolute">
              <Toolbar
                sx={t => ({
                  display: 'flex',
                  justifyContent: 'flex-end',
                  padding: t.spacing(0, 2),
                })}
              >
                <LocaleSelect variant="light" />
              </Toolbar>
            </AppBar>
          </div>
          <div
            style={{
              marginTop: theme.spacing(8),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography component="h1" variant="h5">
              <FormattedMessage defaultMessage="Clinic Administrator Sign In" />
            </Typography>
            <form
              style={{
                width: '100%',
                marginTop: theme.spacing(3),
              }}
              onSubmit={handleSubmit}
              onChange={() => setApiError('')}
            >
              <Grid container spacing={2}>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    id="email"
                    label={<FormattedMessage defaultMessage="Email" />}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    type="email"
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    required
                    fullWidth
                    id="password"
                    label={<FormattedMessage defaultMessage="Password" />}
                    name="password"
                    type="password"
                    autoComplete="current-password"
                    inputProps={{ minLength: 8 }}
                  />
                </Grid>
              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={t => ({
                  margin: t.spacing(3, 0, 2),
                })}
                disabled={!!apiError}
              >
                <FormattedMessage defaultMessage="Sign In" />
              </Button>
            </form>
            {apiError && <Typography color="error">{apiError}</Typography>}
          </div>
        </Container>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

SignIn.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    errorMessage: state.auth.error,
  };
}

export default connect(mapStateToProps, { updateUser })(
  withRouter(injectIntl(SignIn)),
);
